const levelSelectData = [
  {
    heading: "LEVEL 1",
    isLocked: false,

    paragraph:
      "Egestas facilisis tempor, quis viverra auctor sed sem condimentum. Donec sit tempus ac sit parturient eget imperdiet amet, neque.",
    buttonLabel: "LET’S PLAY",

    linkTo: "",

    level: "1",
  },
  {
    heading: "LEVEL 2",
    isLocked: false,

    paragraph:
      "Egestas facilisis tempor, quis viverra auctor sed sem condimentum. Donec sit tempus ac sit parturient eget imperdiet amet, neque.",
    buttonLabel: "LET’S PLAY",

    linkTo: "",
    level: "2",
  },
  {
    heading: "LEVEL 3",
    isLocked: false,

    paragraph:
      "Egestas facilisis tempor, quis viverra auctor sed sem condimentum. Donec sit tempus ac sit parturient eget imperdiet amet, neque.",
    buttonLabel: "LET’S PLAY",

    linkTo: "",
    level: "3",
  },
];

export default levelSelectData;
